import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { MarkdownView } from '@/components/molecules/MarkdownView';
import { Markdown } from '@/types/fields';

interface Props {
  readonly description?: string | Markdown;
}

export const FieldDescription: React.FC<Props> = (props: Props): React.ReactElement => {
  const { description } = props;

  if (!description) {
    return <></>;
  }

  if (typeof description === 'string') {
    if (description.trim() === '') {
      return <></>;
    }

    return (
      <Box mt={1.5}>
        <Typography color="custom.LightGray">{description}</Typography>
      </Box>
    );
  } else {
    return (
      <Box mt={1.5}>
        <MarkdownView content={description} />
      </Box>
    );
  }
};
